
export const mutationTransporte ={
    'SET_TRANSPORT'(transports, stateTransporte){
            stateTransporte.transport = transports
    }
}
